import { Button } from '@interstate/components/Button';
import { Grid } from '@interstate/components/Grid';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

export interface FooterButtonsProps {
    isInsideSlideOut: boolean;
    /** Set by hosts whose cancel returns to an offer in progress — the button then reads "Return to Offer". */
    showReturnToOffer?: boolean;
    onCancelClick: () => void;
}

export const FooterButtons: React.FC<FooterButtonsProps> = ({ isInsideSlideOut, showReturnToOffer = false, onCancelClick }) => {
    const theme = useInterstateTheme();

    const cancelLabel = showReturnToOffer ? 'Return to Offer' : 'Cancel';

    return (
        <div
            className={`change-vehicle-footer ${isInsideSlideOut ? 'change-vehicle-footer--slideout' : ''}`}
            data-testid="change-vehicle-footer"
        >
            <div className="change-vehicle-footer-button-container">
                <Grid
                    container
                    justifyContent="flex-end"
                    gap={1}
                    paddingX={4}
                    paddingY={2}
                    bgcolor={theme.tokens.BaseColorWhite}
                    borderTop="1px solid #B2B2B2"
                    className="change-vehicle-footer-grid"
                >
                    <Button
                        data-testid="btn-cancel-change-vehicle"
                        buttonStyle={showReturnToOffer ? 'secondary' : 'tertiary'}
                        onClick={onCancelClick}
                        sx={{ marginRight: '16px' }}
                    >
                        {cancelLabel}
                    </Button>
                </Grid>
            </div>
        </div>
    );
};
